/* eslint-disable react/react-in-jsx-scope */

const PAYMENT_TYPE_TO_CATEGORY = {
  CREDIT_CARD_NOT_PRESENT: "CARD",
  CREDIT_CARD_PRESENT: "CARD",
  DEBIT_CARD_NOT_PRESENT: "CARD",
  DEBIT_CARD_PRESENT: "CARD",
  AMEX_NOT_PRESENT: "CARD",
  AMEX_PRESENT: "CARD",
  CARDPOINTE_CARD: "CARD",
  COMMERCIAL_CARD: "CARD",
  CORPORATE_CARD: "CARD",
  MANUAL_CARD_TRANSACTION: "CARD",
  PREPAID_CARD: "CARD",
  RUPAY_CREDIT_CARD_NOT_PRESENT: "CARD",
  RUPAY_CREDIT_CARD_PRESENT: "CARD",
  RUPAY_NOT_PRESENT: "CARD",
  RUPAY_PRESENT: "CARD",
  SUPER_PREMIUM_CARD: "CARD",
  QR: "UPI",
  UPI_INDENT: "UPI",
  UPI_NOT_PRESENT: "UPI",
  UPI_PRESENT: "UPI",
  APPLE_PAY_US: "WALLET",
  GOOGLE_PAY_US: "WALLET",
  PAYPAL_WALLET: "WALLET",
  SWIREPAY_US: "WALLET",
  VENMO: "WALLET",
  ZELLE: "WALLET",
};

const getUniquePaymentTypesV2 = (tabs) => {
  if (tabs) {
    const paymentTypes = tabs.map(data => PAYMENT_TYPE_TO_CATEGORY[data]
      ?? (data.includes("NET_BANKING") ? "NET_BANKING" : data));
    const uniquePaymentTypes = [...new Set(paymentTypes)];
    return uniquePaymentTypes;
  }
};

export default getUniquePaymentTypesV2;
